import React, { useEffect } from 'react'
import styles from './public.objects.styl'
import DataGrid from '@src/components/data.grid'
import Tile from '@src/components/common/tile'
import QueryString from 'query-string'
import * as View from '@src/components/common/view.page'
import { getColumns, PublicObjectNames } from './configurations'
import { useHistory, useLocation } from 'react-router-dom'
import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import Tabs, {
  getTabNameWithCount,
  TabItem
} from '@src/components/common/totals.tabs'
import { map } from 'lodash'
import { CSSSelector } from '@src/utils/css.selector.helper'
import { useSelector, useDispatch } from 'react-redux'
import * as ReduxApp from '@src/redux'
import * as Selectors from './selectors'
import * as CommonSelectors from '@src/selectors'
import { defaultPageSize } from '@src/constants/grid'

interface Params {}
interface OwnProps {}

export type Props = OwnProps

export interface State {
  selected: ResourceTypeEnum
}

const filterOptions = {
  hasSearchBar: true,
  placeholder: 'Search'
}

export const CSSSelectors = {
  totalTabs: new CSSSelector('publicObjectsTabs'),
  grid: new CSSSelector('publicObjectsGrid')
}

const PublicObjects: React.FC<Props> = React.memo((props: Props) => {
  const totals = useSelector(Selectors.getTotals)
  const data = useSelector(Selectors.getList)
  const location = useLocation()
  const history = useHistory<Params>()
  const lastUpdate = useSelector(CommonSelectors.getLastUpdate)
  const resourceTypes = useSelector(CommonSelectors.getResourceTypes)

  const dispatch = useDispatch()

  const selected = (QueryString.parse(location.search)?.type ||
    ResourceTypeEnum.INSTANCE) as ResourceTypeEnum

  useEffect(() => {
    dispatch(ReduxApp.Actions.ExternalLists.getPublicObjectsData(selected))
    return () => {
      dispatch(ReduxApp.Actions.ExternalLists.cleaning)
    }
  }, [selected, props])

  function getTabLabel(type: ResourceTypeEnum, count: number) {
    const title =
      PublicObjectNames[type] ||
      resourceTypes[type]?.display_name_plural ||
      type
    return getTabNameWithCount(title, count)
  }

  function onTypeToggle(type: ResourceTypeEnum) {
    history.push(`?type=${type}`)
  }

  const columns = getColumns({
    history,
    selectedType: selected
  })

  const items: TabItem[] = map(totals, (count, type) => ({
    label: getTabLabel(ResourceTypeEnum[type], count),
    value: ResourceTypeEnum[type]
  }))
  return (
    <View.ContentPage noMargin noPadding className={styles.content}>
      <View.HeaderPage className={styles.header} lastUpdate={lastUpdate}>
        Public Objects
      </View.HeaderPage>
      <Tabs
        id={CSSSelectors.totalTabs.value}
        activeTab={selected}
        items={items}
        onChange={onTypeToggle}
      />
      <Tile className={styles.contentWrapper}>
        <DataGrid
          gridId={CSSSelectors.grid.value}
          resourceTypes={resourceTypes}
          filterOptions={filterOptions}
          rowsPerPage={defaultPageSize}
          data={data}
          columns={columns}
        />
      </Tile>
    </View.ContentPage>
  )
})

export default PublicObjects
